import styles from "./NumberStat.module.css";
import NumberFlow from "@number-flow/react";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";

function NumberStat({ value, prefix, suffix, className }) {
    const [ref, isVisible] = useIntersectionObserver(0);
    return (
        <NumberFlow
            ref={ref}
            value={isVisible ? value : 0}
            prefix={prefix}
            suffix={suffix}
            className={[styles.stat, className].join(" ")}
            trend={-1}
            spinTiming={{ duration: 850, easing: "ease-out" }}
        />
    );
}

export default NumberStat;
